import ToggleableSection from 'components/ToggleableSection'

import { AcademicFocusSelector, IAcademicFocusSelector } from '../AcademicFocusSelector'
import CareerSelector from '../CareerSelector'
import { withContext } from '../Context'

export const FocusAndCareerSelector = ({ criteria = 'OneOf', segment, onChange }: IAcademicFocusSelector) => {
  return (
    <ToggleableSection
      title="Academic & Career Interests"
      info="Broad categories of academic disciplines and career clusters"
    >
      <AcademicFocusSelector
        criteria={criteria}
        segment={segment}
        onChange={onChange}
      />
      <CareerSelector />
    </ToggleableSection>
  )
}

export default withContext(FocusAndCareerSelector)
